import { useEffect, useState } from 'react'
import { useSpring, useTrail, animated, config } from 'react-spring'
import { useDebounceValue } from 'usehooks-ts'

import styles from './status-selector.module.scss'

export function StatusSelector ({ availableStatuses = [], activeStatusId, onChange }) {
  const [ isOpen, setIsOpen ] = useState(false)
  const [ debouncedIsOpen ] = useDebounceValue(isOpen, 500)
  const activeStatus = availableStatuses.find(status => status.id === activeStatusId)

  const backgroundColor = useSpring({
    to: isOpen
      ? {
        opacity: 1
      }
      : {
        opacity: 0
      },
    config: config.stiff
  })

  const spring = useSpring({
    to: isOpen
      ? {
        scale: 0.8,
        backgroundColor: activeStatus?.color ?? '#b58eff'
      }
      : {
        opacity: 1,
        scale: 1,
        backgroundColor: activeStatus?.color ?? '#b58eff'
      },
    config: config.stiff
  })

  const [ trail, api ] = useTrail(
    availableStatuses.length,
    () => ({
      from: {
        opacity: 0,
        y: -15,
        scale: 0.85
      },
      config: config.stiff
    })
  )

  useEffect(() => {
    api.start({
      to: isOpen
        ? {
          opacity: 1,
          y: 0,
          scale: 1
        }
        : {
          opacity: 0,
          y: -20,
          scale: 0.85
        },
      config: config.stiff
    })
  }, [ isOpen, api ])

  return (
    <div
      className='flex flex-col relative z-30 items-center'
      style={{
        width: '1.3rem',
        height: '1.3rem'
      }}
    >
      <animated.button
        type='button'
        aria-label='Expand colors'
        title='Select Status'
        onClick={() => {
          setIsOpen(isOpen => !isOpen)
        }}
        style={{
          width: '1.3rem',
          height: '1.3rem',
          borderRadius: '50%',
          backgroundColor: '#b58eff',
          // border: '2.5px solid #5f6367',
          cursor: 'pointer',
          position: 'absolute',
          zIndex: 100,

          ...spring
        }}
      />
      {(debouncedIsOpen || isOpen) && (
        <animated.div
          style={{
            ...backgroundColor,
            boxShadow: '0px 3px 8px 4px rgba(0,0,0,0.10)',
            borderRadius: '10px',
            width: '2.5rem',
            marginTop: '2rem'
          }}
          className='flex flex-col gap-2 items-center py-2 relative bg-white rounded-xl z-30'
        >
          {trail.map((spring, i) => (
            <animated.button
              key={availableStatuses[i].id}
              className={styles.button}
              style={{
                cursor: 'pointer',
                pointerEvents: isOpen ? 'all' : 'none',
                border: 'none',
                ...spring
              }}
              title={availableStatuses[i].description}
              onClick={() => {
                onChange?.(availableStatuses[i].id)
                setIsOpen(false)
              }}
            >
              <div
                style={{
                  width: '1.5rem',
                  height: '1.5rem',
                  backgroundColor: availableStatuses[i].color,
                  // border: '1px solid transparent',
                  // borderColor: availableStatuses[i].color === '#ffffff'
                  //   ? '#5f6367'
                  //   : 'transparent',
                  borderRadius: '50%'
                }}
              />
            </animated.button>
          ))}
        </animated.div>
      )}
    </div>
  )
}
